/**
 * spine-crisis.ts — client-side crisis pre-check for tap-to-match.
 *
 * Runs in the tap handler BEFORE any network call: a prayer signaling
 * acute crisis routes to the care state and NEVER enters matching
 * (rule #76 posture: the gate is plain code, never a model's job).
 *
 * CROSS-BOUNDARY MIRROR (rule #4 sub-rule): these patterns are
 * duplicated in api/_lib/spine-safety.ts (the server's
 * defense-in-depth re-check). Change BOTH files in lockstep;
 * scripts/probe-spine-suggest.mjs section 3 asserts the two copies are
 * string-identical and re-measures false positives against the gold
 * prayers (eval: 4/4 crisis probes caught, 0/97 false positives).
 *
 * Zero-import leaf so any surface (and the probe, under tsx) can use it.
 */

export const CRISIS_PATTERNS = [
  'kill (myself|me)',
  'end(ing)? (my|it|this) (life|all)',
  'suicid',
  'self[- ]harm',
  'hurt myself',
  "don'?t want to (be alive|live|wake up)",
  'overdose',
  'no reason to (live|go on)',
  'better off without me',
  'cutting myself',
  'want to die',
  'end my life',
] as const;

const CRISIS_RX = new RegExp(CRISIS_PATTERNS.join('|'), 'i');

export function isCrisisPrayer(prayer: string): boolean {
  return CRISIS_RX.test(prayer);
}
